import {FC} from 'react'
import AditionalFormCentral from './aditionalCampCentral'
import AditionalFormHotel from './aditionalCampHotel'
interface Props {
  isDisabled?: boolean
  module?: string
}
const AditionalCamp: FC<Props> = ({isDisabled = false, module = 'central'}) => {
  if (module === 'central' || module === 'lavanderia') {
    return <AditionalFormCentral isDisabled={isDisabled} />
  } else {
    return <AditionalFormHotel isDisabled={isDisabled} />
  }
}

export default AditionalCamp
